import apiClient from './apiClient';

export const fetchRevenue = (params) => {
  return apiClient.get('/admin/revenue', { params });
};